{
  "moreActions": "その他のアクション"
}
